import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import utils from '../../utils/utils';
import DATE_FORMAT from '../../components/constants/dateFormat';
import apiCalls from '../../utils/apiCalls';
import { FormattedMessage, injectIntl } from 'react-intl';
import { faReceipt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AdminOrderRow = ({ orderBatch, getOrderBatches, intl }) => {
  const dateCreated = utils.getDateFromString(orderBatch.dateCreated).format(DATE_FORMAT.displayWithTimeAndWeekday);

  function deleteOrderBatch() {
    const confirmMessage = intl.formatMessage({ id: 'admin.orders.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      apiCalls
        .deleteOrderBatch(orderBatch.id)
        .then(() => {
          getOrderBatches();
        })
        .catch((errors) => {
          window.alert(utils.getErrorMessageFromResponse(errors, true));
        });
    }
  }

  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/orderBatches/${orderBatch.id}`} className="link">
          {orderBatch.id}
        </Link>
      </th>
      <td>
        {orderBatch.businessProfile ? (
          <div>
            <strong>B2B:</strong> {orderBatch.businessProfile.companyName}
          </div>
        ) : (
          ''
        )}
        <div>
          <Link
            to={`/admin/users/${orderBatch.user.id}`}
            className={`${orderBatch.businessProfile ? 'text-small' : ''}`}
          >
            #{orderBatch.user.id} - {orderBatch.user.screenName}
          </Link>
        </div>
      </td>
      <td>{orderBatch.finalSum}€</td>
      <td className={orderBatch.payment && orderBatch.payment.status !== 'COMPLETED' ? 'text-warning' : ''}>
        <div>{orderBatch.payment ? orderBatch.payment.status : ''}</div>
        {orderBatch.payment.invoicePaymentStatus ? (
          <div>
            <small>
              <FontAwesomeIcon icon={faReceipt} />{' '}
              <FormattedMessage
                id={`admin.orders.order.invoice.payment.status.${orderBatch.payment.invoicePaymentStatus}`}
              />
            </small>
          </div>
        ) : (
          ''
        )}
      </td>
      <td>
        {orderBatch.coupon
          ? `${orderBatch.coupon.code} - ${
              orderBatch.coupon.discountPercent
                ? `${orderBatch.coupon.discountPercent}%`
                : `${orderBatch.coupon.discountSum}€`
            }`
          : ''}
      </td>
      <td>{orderBatch.platform}</td>
      <td>{dateCreated}</td>
      <td>
        <button className="btn btn-normal-link" onClick={deleteOrderBatch}>
          Delete
        </button>
        <br />
      </td>
    </tr>
  );
};

AdminOrderRow.propTypes = {
  orderBatch: PropTypes.object.isRequired,
  getOrderBatches: PropTypes.func.isRequired,
};

AdminOrderRow.defaultProps = {};

export default injectIntl(AdminOrderRow);
